import React from "react";

export const Logo = ({ className = "", size = "default" }) => {
  const sizes = {
    small: { width: 36, height: 36, text: "text-xs" },
    default: { width: 44, height: 44, text: "text-sm" },
    large: { width: 56, height: 56, text: "text-base" },
  };

  const { width, height } = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {/* Logo SVG */}
      <svg
        width={width}
        height={height}
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0"
      >
        {/* Background */}
        <rect width="60" height="60" rx="12" fill="#0E3A5B" />
        
        {/* Scaffolding structure - stylized */}
        {/* Vertical bars */}
        <rect x="14" y="12" width="4" height="36" fill="#F0B429" rx="1" />
        <rect x="42" y="12" width="4" height="36" fill="#F0B429" rx="1" />
        
        {/* Horizontal bars (planks) */}
        <rect x="12" y="18" width="36" height="3" fill="white" rx="1" />
        <rect x="12" y="28" width="36" height="3" fill="white" rx="1" />
        <rect x="12" y="38" width="36" height="3" fill="white" rx="1" />
        
        {/* Cross braces */}
        <path
          d="M18 21L42 35"
          stroke="#5C728A"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M42 21L18 35"
          stroke="#5C728A"
          strokeWidth="2"
          strokeLinecap="round"
        />
        
        {/* Small accent details */}
        <circle cx="16" cy="46" r="2" fill="#F0B429" />
        <circle cx="44" cy="46" r="2" fill="#F0B429" />
      </svg>
    </div>
  );
};

export const LogoWithText = ({ className = "", inverted = false, size = "default" }) => {
  const textColor = inverted ? "text-white" : "text-primary";
  
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <Logo size={size} />
      <div className="flex flex-col">
        <span className={`font-bold text-lg leading-tight ${textColor}`}>
          Gerüst Sanierung
        </span>
        <span className={`text-xs ${inverted ? "text-white/70" : "text-secondary"}`}>
          Robert Recher
        </span>
      </div>
    </div>
  );
};
